module.exports = __webpack_public_path__ + "img/wheat-slash.0e7723fe.svg";